var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    class: { dense_input: _vm.dense },
    attrs: {
      value: _vm.value,
      rules: _vm.rules,
      items: _vm.items,
      loading: _vm.loading,
      "item-text": "name",
      "item-value": "code",
      "search-input": _vm.search,
      readonly: _vm.readonly,
      disabled: _vm.disabled,
      solo: _vm.solo,
      "hide-details": _vm.hide_details,
      dense: "",
      "menu-props": { contentClass: "select-background-base" },
      "hide-no-data": "",
      "append-icon": "",
      clearable: _vm.clearable,
      placeholder: _vm.placeholder || "Rechercher un ayant-droit",
      hint: _vm.hint
    },
    on: {
      change: function($event) {
        return _vm.$emit("change", $event)
      },
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "click:clear": function($event) {
        return _vm.$emit("change", null)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "label",
        fn: function() {
          return [
            _vm.param
              ? _c("span", [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm._f("maestroParamLabel")(_vm.param)) +
                      "\n\t\t"
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "selection",
        fn: function(ref) {
          var item = ref.item
          return [
            _c(
              "v-list-tile-content",
              { attrs: { title: item.code + " | " + item.name } },
              [_c("v-list-tile-title", [_vm._v(_vm._s(item.name))])],
              1
            )
          ]
        }
      },
      {
        key: "item",
        fn: function(ref) {
          var item = ref.item
          return [
            _c(
              "v-list-tile-content",
              { attrs: { title: item.code + " | " + item.name } },
              [
                _c("v-list-tile-title", [_vm._v(_vm._s(item.name))]),
                _vm._v(" "),
                _c("v-list-tile-sub-title", [_vm._v(_vm._s(item.code))])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-list-tile-action",
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      flat: "",
                      icon: "",
                      title: "copier le code client " + item.code
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.copyOwnerCode(item.code)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { small: "" } }, [
                      _vm._v("content_copy")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      },
      {
        key: "append",
        fn: function() {
          return [
            _vm.value
              ? _c(
                  "v-btn",
                  {
                    staticClass: "ma-0",
                    attrs: {
                      small: "",
                      flat: "",
                      icon: "",
                      title: "copier le code client " + _vm.value
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.copyOwnerCode(_vm.value)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { small: "" } }, [
                      _vm._v("content_copy")
                    ])
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d4fdb64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d4fdb64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/field_owner.vue
// module id = null
// module chunks = 